import confetti from 'canvas-confetti';

/**
 * A celebratory confetti burst. Fires two angled cannons from the bottom
 * corners so the effect reads well across the full width of the page.
 */
export function confettiBlast(): void {
  const defaults = {
    spread: 60,
    startVelocity: 55,
    ticks: 200,
    zIndex: 9999,
  };

  confetti({
    ...defaults,
    particleCount: 80,
    angle: 60,
    origin: { x: 0, y: 0.9 },
  });
  confetti({
    ...defaults,
    particleCount: 80,
    angle: 120,
    origin: { x: 1, y: 0.9 },
  });
}

/**
 * A bigger, screen-wide celebration: an immediate center cannon plus a short
 * sequence of randomly-placed bursts so confetti rains down across the whole
 * viewport. Used when a new import is successfully started.
 */
export function confettiEverywhere(durationMs = 1600): void {
  const zIndex = 9999;

  // Immediate big burst from the middle-bottom.
  confetti({
    particleCount: 160,
    spread: 100,
    startVelocity: 55,
    ticks: 220,
    origin: { x: 0.5, y: 0.65 },
    zIndex,
  });

  // Sustained rain of bursts at random positions across the top of the screen.
  const animationEnd = Date.now() + durationMs;
  const rand = (min: number, max: number) => Math.random() * (max - min) + min;

  const interval = window.setInterval(() => {
    const timeLeft = animationEnd - Date.now();
    if (timeLeft <= 0) {
      window.clearInterval(interval);
      return;
    }
    // Taper the particle count as the effect winds down.
    const particleCount = Math.max(20, Math.floor(60 * (timeLeft / durationMs)));
    confetti({
      particleCount,
      spread: 360,
      startVelocity: 30,
      ticks: 90,
      origin: { x: rand(0.1, 0.4), y: rand(-0.1, 0.3) },
      zIndex,
    });
    confetti({
      particleCount,
      spread: 360,
      startVelocity: 30,
      ticks: 90,
      origin: { x: rand(0.6, 0.9), y: rand(-0.1, 0.3) },
      zIndex,
    });
  }, 220);
}
